import aceRequest from '../ace-request';
import aceError from '../error';

window.atex = window.atex || {};
window.atex.aceui = window.atex.aceui || {};
window.atex.aceui.service = window.atex.aceui.service || {};

atex.aceui.service.CognitoService = (serviceUrl, { adaptedAxios } = {}) => {
  let rejectedNotEnabledError = () => {
    return Promise.reject (aceError.Error ({
      origin: 'atex.aceui.service.CognitoService',
      type: aceError.types.RUNTIME,
      cause: 'Cognito is not enabled.'
    }));
  };

  return {
    info: ({ token }) => {
      if (!serviceUrl) {
        return Promise.resolve ({ enabled: false });
      }

      return aceRequest ({ url: `${serviceUrl}/status`, token }, adaptedAxios)
        .then (response => response.body);
    },

    inviteUser: ({ username, email, token }) => {
      if (!serviceUrl) {
        return rejectedNotEnabledError();
      }

      return aceRequest ({
        method: 'POST',
        url: `${serviceUrl}/invite/${username}`,
        token,
        body: { email }
      })
        .then (response => response.body);
    },

    disableUser: ({ username, token }) => {
      if (!serviceUrl) {
        return rejectedNotEnabledError();
      }

      return aceRequest ({
        method: 'PUT',
        url: `${serviceUrl}/disable/${username}`,
        token
      })
        .then (response => response.body);
    },

    enableUser: ({ username, token }) => {
      if (!serviceUrl) {
        return rejectedNotEnabledError();
      }

      return aceRequest ({
        method: 'PUT',
        url: `${serviceUrl}/enable/${username}`,
        token
      })
        .then (response => response.body);
    }
  };
};
